import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as actions from '../actions/dashboard.actions';
import { DashboardSelectors } from '../selectors/dashboard.selectors';
import { ContactPayload, DashboardState } from '../state/dashboard.state';

@Injectable({
  providedIn: 'root',
})
export class DashboardFacade {
  searchedContacts$ = this.selectors.getSearchedContacts$;
  searchedContact$ = this.selectors.getSearchedContact$;
  dashboardNavigationList$ = this.selectors.getDashboardNavigationList$;
  balancesOverview$ = this.selectors.getBalancesOverview$;
  isAddContactProcessing$ = this.selectors.getIsAddContactProcessing$;
  recentTransactionActivities$ = this.selectors.getRecentTransactionActivities$;
  isRecentTransactionsLoading$ = this.selectors.getIsRecentTransactionsLoading$;
  recentTransactionsError$ = this.selectors.getRecentTransactionsError$;

  constructor(
    private store: Store<DashboardState>,
    private selectors: DashboardSelectors,
  ) {}

  getSearchedContacts(searchedContact: string): void {
    this.store.dispatch(actions.getSearchContacts({ searchedContact }));
  }

  resetSearchedContacts(): void {
    this.store.dispatch(actions.resetSearchedContacts());
  }

  addChosenContact(payload: ContactPayload): void {
    this.store.dispatch(actions.addChosenContact({ payload }));
  }

  inviteChosenContact(): void {
    this.store.dispatch(actions.inviteChosenContact());
  }

  getBalancesOverview(): void {
    this.store.dispatch(actions.getBalancesOverview());
  }

  getRecentTransactions(selectedYear: number): void {
    this.store.dispatch(actions.getRecentTransactions({ selectedYear }));
  }
}
